import { render, staticRenderFns } from "./MaDeviation.vue?vue&type=template&id=ba222688&scoped=true"
import script from "./MaDeviation.vue?vue&type=script&lang=js"
export * from "./MaDeviation.vue?vue&type=script&lang=js"
import style0 from "./MaDeviation.vue?vue&type=style&index=0&id=ba222688&prod&scoped=true&lang=css"
import style1 from "./MaDeviation.vue?vue&type=style&index=1&id=ba222688&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba222688",
  null
  
)

export default component.exports